export default __webpack_public_path__ + "static/media/tarekcover.cb9f101b.jpg";